import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "", immediate = false }) => (
  <motion.span
    className={`block overflow-hidden ${className}`}
    initial="hidden"
    {...(immediate
      ? { animate: "visible" }
      : { whileInView: "visible", viewport: { once: true } })}
  >
    <motion.span
      className="block"
      variants={{ hidden: { y: "110%" }, visible: { y: 0 } }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const EASING = EASE;
